import styled from "styled-components";

const SVGWrapper = styled.svg`
  width: 120px;
  @media (max-width: 640px) {
    width: 100px;
  }
`;

const Spana_Logo = () => {
  return (
    <SVGWrapper
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2048.000000 2048.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"
        fill="#253569"
        stroke="none"
      >
        <path
          d="M11186 16849 c-71 -10 -154 -26 -185 -35 -118 -34 -262 -128 -296
-195 -9 -17 -15 -56 -15 -98 0 -60 -5 -78 -36 -138 -95 -180 -284 -363 -468
-453 -197 -96 -539 -115 -808 -45 -229 60 -393 146 -670 353 -216 161 -321
232 -356 242 -46 12 -108 12 -192 0 -36 -6 -112 -14 -170 -20 -110 -9 -268
-51 -408 -109 -145 -59 -187 -108 -203 -238 -13 -100 -34 -153 -106 -259 -70
-105 -91 -143 -208 -369 -49 -93 -102 -189 -118 -213 -44 -61 -111 -109 -292
-208 -88 -48 -196 -110 -240 -138 -103 -65 -276 -188 -272 -193 5 -4 209 -56
329 -84 132 -30 324 -35 515 -15 128 14 179 15 315 6 343 -22 435 -30 488 -40
30 -6 141 -11 246 -10 148 0 200 -3 234 -15 27 -10 60 -13 85 -10 22 3 121 10
220 15 244 13 270 21 509 156 38 21 87 59 110 83 139 150 315 302 430 371 l39
23 -7 -75 c-9 -95 7 -216 44 -333 23 -72 50 -192 50 -226 0 -4 -17 -3 -37 2
-21 5 -74 17 -118 25 l-81 16 -89 -35 c-93 -37 -98 -43 -81 -92 7 -18 6 -18
-12 3 -11 12 -22 28 -24 34 -3 7 -12 9 -22 5 -14 -5 -17 -14 -13 -35 5 -27 5
-27 -12 -6 -13 16 -22 19 -39 13 -29 -11 -35 -29 -22 -65 l11 -29 -28 27 -28
27 -45 -38 -45 -39 20 -22 20 -23 -22 12 c-35 18 -55 13 -111 -25 l-53 -35 23
-19 c26 -22 12 -26 -26 -8 -22 9 -29 8 -46 -7 -18 -16 -18 -20 -5 -46 23 -43
18 -47 -12 -11 l-28 33 -44 -39 -45 -39 22 -41 c25 -49 21 -51 -25 -16 -27 21
-37 23 -48 14 -13 -11 -12 -17 6 -46 11 -19 16 -34 10 -34 -5 0 -14 6 -18 13
-4 6 -15 18 -24 24 -13 11 -19 10 -32 -5 -15 -17 -14 -21 14 -56 17 -20 29
-39 27 -41 -2 -3 -21 7 -41 20 -20 14 -40 25 -45 25 -16 0 -123 -121 -117
-131 4 -5 14 -9 23 -9 9 0 26 -8 37 -16 19 -15 19 -15 -8 -9 -49 12 -90 -2
-115 -40 -21 -33 -25 -35 -80 -35 -81 0 -205 -24 -335 -64 -358 -111 -510
-139 -767 -140 -278 0 -483 31 -865 134 -325 88 -359 94 -585 94 -219 0 -353
-14 -595 -66 -67 -14 -216 -85 -291 -139 -84 -61 -223 -214 -278 -307 -26 -42
-60 -113 -77 -157 -28 -71 -32 -95 -36 -210 -3 -71 0 -251 6 -400 15 -337 14
-351 -10 -680 -24 -335 -32 -384 -76 -515 -30 -87 -37 -127 -45 -233 -7 -103
-13 -138 -32 -175 -15 -30 -26 -75 -31 -122 -4 -44 -21 -116 -41 -174 -19 -54
-33 -101 -30 -103 5 -5 76 114 76 128 0 6 4 8 9 5 16 -11 -21 -161 -58 -234
-41 -81 -16 -79 43 3 22 30 41 53 43 52 2 -2 -2 -18 -8 -36 -6 -18 -9 -34 -6
-37 8 -8 55 76 74 132 15 44 17 46 23 24 8 -32 16 -17 25 45 4 28 12 57 17 65
6 10 7 3 2 -20 -11 -61 12 -20 31 55 10 39 27 87 37 108 28 56 39 125 48 302
19 359 77 975 116 1237 7 54 14 116 14 138 0 22 4 40 9 40 21 0 51 -104 65
-226 27 -237 36 -474 40 -1114 4 -642 3 -663 -34 -810 -28 -109 -30 -140 -6
-121 11 9 14 -10 19 -111 3 -68 14 -170 25 -228 12 -58 28 -154 37 -215 9 -60
32 -194 51 -296 53 -294 54 -353 8 -564 -10 -46 -14 -92 -10 -108 3 -15 38
-59 76 -97 54 -54 70 -77 75 -107 3 -21 10 -58 16 -83 6 -25 13 -66 16 -92 l5
-48 -353 0 c-340 0 -352 1 -336 18 60 66 -33 189 -172 228 -31 9 -64 25 -73
36 -25 28 -32 83 -19 142 8 36 8 74 1 130 -14 110 -12 117 252 751 l104 250
-7 175 c-7 183 -20 252 -60 317 -12 19 -25 31 -29 26 -12 -13 -50 -135 -50
-160 0 -39 -15 -25 -30 29 -8 28 -20 53 -27 55 -16 6 -36 -45 -52 -127 -18
-90 -60 -178 -109 -225 -27 -26 -48 -58 -58 -90 -20 -59 -99 -244 -144 -333
-17 -35 -40 -100 -51 -145 -40 -168 -41 -169 -95 -228 -60 -65 -79 -98 -89
-152 -6 -33 -2 -46 30 -99 54 -87 58 -123 29 -236 -13 -51 -24 -107 -24 -126
0 -72 48 -152 123 -207 l40 -29 -309 -2 -309 -3 0 -220 0 -220 6985 0 6985 0
3 223 2 222 -2498 0 -2499 0 -33 51 c-41 64 -76 81 -235 109 -167 29 -228 69
-249 165 -4 17 -33 81 -64 144 l-57 114 2 101 c1 56 4 110 7 121 3 12 44 47
93 80 48 33 127 94 175 136 121 108 215 181 271 213 26 15 101 68 168 119 181
139 208 156 281 178 57 17 74 27 107 67 196 232 207 247 217 324 4 30 1 54
-10 78 -10 19 -22 46 -29 60 -7 14 -80 162 -164 329 -83 167 -173 351 -199
410 -58 133 -173 440 -270 720 l-74 214 30 106 c17 58 41 160 55 226 l25 120
67 60 c38 33 121 111 185 174 l118 115 92 -18 c259 -52 559 -18 924 103 356
118 726 356 1089 701 39 36 165 148 281 247 299 257 404 375 632 711 304 449
413 559 625 634 61 22 96 28 159 28 44 0 124 7 177 16 79 14 111 15 178 6 45
-6 97 -19 115 -28 50 -26 106 -24 129 5 40 49 13 170 -45 200 -29 16 -25 31 8
31 34 0 164 36 181 50 25 21 17 69 -22 134 -48 81 -60 94 -94 101 -36 8 -43
19 -28 43 19 30 2 73 -50 123 -90 87 -193 129 -346 143 -38 4 -106 17 -150 31
-95 28 -162 40 -310 55 -115 11 -350 63 -397 86 -28 14 -78 73 -78 91 0 5 -19
39 -42 74 -27 42 -44 80 -47 109 -6 42 -8 45 -39 48 -38 4 -76 -9 -210 -67
-144 -64 -222 -81 -364 -81 -220 0 -291 -29 -457 -185 -63 -60 -68 -62 -131
-69 -123 -13 -286 -48 -326 -69 -23 -14 -40 -31 -42 -44 -5 -32 66 -104 140
-143 35 -18 65 -34 66 -36 9 -7 -13 -48 -59 -110 -39 -53 -49 -73 -44 -94 3
-14 -3 -51 -14 -83 -30 -87 -43 -171 -42 -279 1 -92 -1 -99 -34 -164 -67 -128
-216 -278 -313 -314 -95 -36 -264 -23 -446 33 -59 18 -81 31 -139 86 -80 75
-177 195 -307 376 -51 72 -95 132 -96 134 -2 2 -12 -4 -23 -13 -25 -23 -61
-168 -61 -246 0 -71 13 -100 70 -155 51 -49 98 -113 136 -185 16 -30 41 -71
55 -90 15 -19 44 -68 65 -109 43 -86 55 -179 35 -280 -14 -69 -2 -163 27 -220
133 -262 132 -261 255 -383 64 -65 117 -122 117 -126 0 -5 36 -45 79 -90 88
-88 104 -126 82 -188 -9 -25 -9 -44 -2 -71 15 -52 14 -117 -3 -156 -18 -44
-68 -85 -114 -93 -42 -8 -84 -27 -127 -59 -36 -27 -172 -87 -246 -109 -72 -22
-124 -20 -237 8 -53 13 -126 27 -162 31 -87 8 -136 34 -206 107 -47 49 -188
148 -211 148 -3 0 -46 -37 -97 -83 -120 -109 -224 -197 -280 -237 -32 -23 -54
-51 -75 -94 -27 -55 -33 -86 -61 -317 -43 -366 -77 -557 -128 -726 -66 -215
-236 -355 -432 -355 -87 0 -137 15 -205 62 l-48 33 6 -164 c7 -172 23 -265 86
-504 42 -159 58 -265 71 -470 12 -180 38 -446 70 -709 25 -202 25 -216 1 -216
-10 0 -35 7 -54 15 -51 21 -75 19 -117 -10 -35 -24 -38 -25 -73 -10 -46 19
-127 19 -172 1 -91 -38 -205 -190 -260 -347 -14 -37 -13 -38 26 -82 41 -47 47
-72 28 -125 -12 -36 -4 -52 49 -97 l33 -28 37 30 c72 57 197 137 242 154 34
13 63 16 107 12 60 -6 61 -5 105 36 38 34 52 41 86 41 22 0 44 -5 47 -11 4 -6
9 -46 12 -90 6 -76 5 -81 -26 -130 -17 -28 -31 -61 -31 -73 0 -13 23 -58 51
-101 l50 -78 -7 -98 -7 -99 -988 0 -989 0 -21 43 c-29 58 -82 121 -129 154
-22 15 -47 44 -56 63 -9 19 -28 47 -42 63 -24 25 -26 33 -23 108 1 49 -4 101
-13 132 -23 81 -49 488 -41 647 6 116 11 141 32 182 22 41 24 57 21 130 -2 46
-10 104 -18 130 -12 40 -12 97 -1 380 6 183 12 379 12 434 0 56 4 130 9 165 8
59 13 68 55 106 25 23 88 71 139 107 117 82 145 114 203 235 32 66 57 103 75
114 48 28 76 110 108 317 10 64 20 86 64 151 28 41 74 102 103 135 29 32 83
102 120 154 40 56 77 96 88 98 72 11 94 41 123 163 9 38 22 69 27 69 17 0 88
-41 131 -76 22 -19 61 -43 86 -54 62 -27 98 -67 137 -152 97 -211 101 -218
152 -258 53 -42 129 -70 189 -70 88 0 215 62 244 118 8 15 21 54 29 86 9 32
32 84 53 114 l37 56 -9 116 c-9 107 -13 121 -56 210 -64 133 -75 181 -82 360
-3 85 -12 196 -20 245 -9 50 -16 113 -16 140 0 45 -11 103 -51 285 -12 53 -11
57 22 127 19 40 39 73 45 73 6 0 17 7 24 15 20 24 4 76 -46 150 -43 64 -45 71
-39 115 8 55 -7 91 -86 206 -27 39 -49 82 -49 96 0 43 101 316 132 355 5 7 35
17 66 23 100 21 378 147 417 190 12 14 14 29 9 67 -6 45 -16 61 -111 169 -146
166 -185 218 -227 302 -49 98 -110 312 -103 364 8 59 31 88 70 88 42 0 72 -31
122 -127 44 -85 120 -164 255 -266 52 -40 115 -89 139 -109 24 -21 54 -38 66
-38 12 0 39 -12 60 -26 37 -25 40 -25 71 -11 46 23 100 31 121 19 14 -9 24 -5
51 21 26 26 42 32 79 33 48 2 56 7 95 65 l16 24 34 -32 c19 -18 39 -33 44 -33
6 0 31 23 56 50 44 48 48 50 85 44 27 -4 55 1 96 16 31 12 57 24 57 27 0 13
-81 77 -145 115 -199 118 -392 292 -448 404 -42 84 -94 239 -107 320 -18 108
-124 233 -236 278 -123 50 -284 57 -508 25z m-152 -1118 c-29 -69 -29 -69 -5
-123 25 -56 50 -205 51 -299 0 -46 -4 -59 -24 -78 -13 -13 -26 -39 -30 -62 -4
-22 -13 -51 -21 -63 -14 -20 -14 -31 0 -95 21 -103 20 -133 -10 -161 -14 -13
-25 -33 -25 -45 0 -12 -7 -30 -15 -41 -8 -10 -15 -35 -15 -54 0 -19 -7 -43
-15 -53 -7 -11 -17 -48 -20 -83 -5 -41 -12 -64 -20 -64 -20 0 -45 121 -45 220
0 50 -5 111 -11 135 -19 77 15 473 56 651 33 142 98 254 139 238 11 -4 15 -12
10 -23z m-1117 -186 c27 -72 94 -181 152 -249 57 -67 69 -110 49 -171 -10 -32
-18 -41 -40 -43 -32 -4 -32 -4 -14 -40 7 -15 13 -50 12 -78 -1 -43 -6 -55 -31
-78 -17 -15 -25 -29 -20 -32 34 -15 35 -19 24 -80 -6 -32 -20 -84 -31 -115
-12 -35 -17 -66 -12 -83 4 -18 1 -33 -8 -44 -9 -9 -18 -29 -22 -44 -3 -15 -13
-34 -22 -43 -15 -15 -18 -15 -36 2 -17 15 -19 29 -17 108 2 76 -2 102 -25 164
-14 41 -33 113 -42 160 -9 47 -25 120 -35 162 -17 69 -18 92 -9 225 17 253 29
310 73 330 28 13 31 10 54 -51z m358 -313 c57 -20 216 -131 245 -172 20 -28
20 -28 -5 -101 -14 -40 -29 -77 -33 -81 -15 -15 -46 31 -51 75 -6 39 -9 43
-51 56 -45 14 -56 13 -157 -26 -10 -4 -13 14 -13 69 0 66 -11 123 -35 181 -6
14 -2 17 21 17 16 -1 52 -8 79 -18z m11 -1267 c42 -14 88 -25 101 -25 17 0 47
-21 94 -67 85 -81 97 -116 101 -286 2 -96 0 -119 -12 -127 -26 -17 -40 -11
-57 25 -20 41 -53 55 -137 55 -37 0 -77 8 -101 19 -47 21 -102 80 -111 119 -4
15 -18 42 -32 61 -21 28 -26 47 -29 117 -4 79 -3 85 21 109 32 32 64 32 162 0z
m698 -858 c13 -59 30 -62 34 -5 2 23 8 48 14 55 18 23 55 15 77 -16 18 -25 21
-44 21 -138 0 -138 18 -211 80 -331 48 -94 49 -100 56 -208 l7 -112 -31 -38
c-16 -22 -40 -70 -52 -109 -13 -38 -27 -75 -32 -82 -16 -20 -91 -52 -146 -63
-129 -24 -280 52 -322 162 -6 18 -34 80 -60 138 -59 128 -67 162 -45 184 9 9
25 16 35 16 29 0 32 14 16 77 -29 117 -29 108 13 152 23 24 41 54 45 76 6 29
11 35 25 30 28 -9 49 19 56 73 9 68 30 110 60 118 19 5 26 14 31 43 l6 36 51
-5 51 -5 10 -48z m-4363 -1858 c149 -59 412 -134 626 -178 121 -25 220 -26
438 -6 88 8 203 16 255 17 l95 3 96 -53 c129 -72 132 -77 130 -251 -2 -156
-17 -381 -31 -461 -5 -30 -15 -107 -20 -170 -6 -66 -21 -148 -35 -193 -29 -91
-31 -122 -9 -202 21 -79 13 -238 -26 -517 -32 -227 -51 -318 -74 -363 -28 -54
-30 -91 -6 -163 18 -54 20 -72 11 -95 l-11 -29 -34 20 c-18 11 -82 37 -142 57
-60 21 -117 46 -126 57 -10 11 -20 36 -23 56 -25 148 -16 133 -149 259 -16 14
-82 278 -192 768 -31 135 -75 260 -240 676 -19 48 -34 100 -34 116 0 50 39
146 73 183 31 32 67 83 67 94 0 2 -28 7 -62 11 -158 16 -357 79 -538 170 -62
31 -113 55 -115 53 -1 -2 -30 -93 -63 -203 -157 -510 -152 -582 48 -710 74
-47 76 -50 399 -545 93 -144 200 -331 279 -490 83 -166 87 -178 85 -235 -4
-99 3 -118 71 -200 35 -42 66 -89 70 -105 3 -16 0 -57 -7 -92 -20 -110 -16
-152 18 -188 l29 -30 -379 2 -379 3 -8 31 c-4 17 -19 36 -34 44 -14 8 -37 33
-51 57 -29 50 -80 97 -137 125 -22 11 -57 41 -76 65 -19 25 -65 77 -102 117
-65 69 -98 125 -98 164 0 11 -24 66 -54 123 -59 113 -113 265 -152 424 -21 89
-24 122 -24 307 0 247 14 363 71 573 22 83 53 200 69 260 16 61 38 164 49 230
22 131 61 487 61 560 l0 45 168 -84 c93 -47 193 -95 223 -107z m5355 -469 c70
-132 139 -246 195 -320 47 -63 98 -138 114 -165 16 -28 33 -51 37 -53 4 -2 8
-18 8 -35 0 -28 -16 -48 -117 -147 -217 -212 -558 -533 -574 -538 -19 -7 -8
169 22 353 53 335 77 496 98 680 18 152 51 487 51 520 0 13 31 -42 166 -295z
m-6518 -377 c-1 -166 -1 -166 56 -316 15 -38 46 -155 71 -260 24 -106 60 -246
79 -312 50 -167 93 -360 111 -497 17 -131 21 -144 41 -152 9 -3 14 -20 14 -43
0 -51 25 -165 44 -201 27 -52 43 -62 101 -62 68 0 81 -17 95 -121 5 -41 14
-87 19 -102 l11 -27 -206 0 -205 0 -30 33 c-17 17 -43 50 -59 73 -16 22 -45
53 -64 68 -20 15 -36 31 -36 36 0 6 -27 48 -60 95 -70 98 -95 157 -79 186 15
29 1 85 -48 182 -30 61 -46 109 -53 155 -5 37 -14 104 -20 148 -7 50 -10 175
-8 325 l4 244 41 100 c34 83 143 454 168 573 4 17 8 32 10 32 3 0 4 -71 3
-157z m3235 -656 c9 -21 26 -52 38 -68 17 -25 23 -57 35 -187 7 -86 21 -239
30 -338 l18 -181 -23 -77 c-25 -83 -20 -119 21 -178 11 -15 25 -54 31 -87 10
-46 21 -68 56 -106 l43 -47 -7 -76 c-4 -43 -9 -80 -12 -84 -2 -5 -110 -8 -239
-8 l-235 0 -19 46 c-43 98 -61 168 -54 207 3 20 0 59 -7 86 -10 40 -9 63 4
137 10 49 31 168 48 264 69 396 105 557 145 653 16 38 28 92 34 155 7 75 44
246 61 282 2 3 5 -76 9 -175 4 -138 10 -189 23 -218z"
        />
        <path
          d="M10214 13845 c-28 -28 -24 -46 24 -97 21 -23 34 -28 73 -28 42 0 51
-4 87 -41 52 -54 77 -49 69 12 -6 48 -45 93 -91 109 -17 5 -39 24 -48 40 -23
40 -77 42 -114 5z"
        />
        <path
          d="M10788 12493 c-59 -60 -74 -132 -43 -193 15 -30 33 -36 94 -32 13 1
36 -8 52 -18 33 -24 45 -25 53 -4 20 51 -2 95 -67 133 -41 25 -52 52 -44 112
3 21 2 39 -2 39 -4 0 -23 -17 -43 -37z"
        />
        <path
          d="M4185 7704 c-113 -17 -211 -39 -289 -65 -366 -122 -615 -374 -708
-717 -17 -63 -21 -106 -21 -237 -1 -141 3 -171 25 -255 83 -307 272 -517 698
-772 105 -63 232 -137 596 -348 170 -98 346 -250 420 -362 144 -216 121 -460
-60 -643 -161 -163 -371 -236 -631 -220 -320 19 -577 79 -863 200 -62 27 -114
46 -116 44 -9 -10 -206 -432 -203 -435 2 -2 57 -28 123 -58 225 -102 427 -161
694 -203 168 -26 609 -26 730 1 444 96 793 341 958 671 192 384 106 835 -220
1156 -141 138 -281 235 -683 474 -547 325 -642 389 -740 496 -100 110 -153
252 -141 381 17 185 131 315 336 384 84 28 88 29 320 29 186 0 254 -4 325 -18
139 -28 258 -63 398 -118 71 -28 130 -49 132 -47 8 7 185 428 185 438 0 24
-258 119 -431 160 -193 45 -336 61 -574 65 -126 2 -243 1 -260 -1z"
        />
        <path
          d="M9057 7643 c-3 -5 -46 -109 -97 -233 -51 -124 -114 -277 -140 -340
-44 -106 -450 -1091 -525 -1275 -115 -280 -348 -847 -365 -885 -11 -25 -63
-151 -116 -280 -137 -335 -153 -374 -318 -774 -36 -88 -66 -164 -66 -168 0 -5
127 -7 282 -6 l283 3 22 55 c12 30 88 217 168 415 80 198 165 408 188 467 l42
108 700 -3 699 -2 73 -195 c40 -107 87 -233 104 -280 17 -47 41 -112 54 -145
12 -33 53 -142 90 -243 l68 -182 558 0 559 0 2 1441 3 1441 535 -666 c294
-367 555 -693 580 -725 25 -32 263 -330 530 -662 266 -332 525 -655 574 -716
l90 -113 482 0 c376 0 483 3 487 13 13 34 341 845 376 932 23 54 41 100 41
102 0 2 314 3 699 3 l699 0 10 -27 c22 -54 165 -441 259 -698 52 -143 101
-275 108 -292 l14 -33 320 0 c177 0 321 2 321 5 0 5 -374 1004 -395 1055 -8
19 -50 132 -94 250 -44 118 -116 310 -160 425 -134 356 -652 1733 -697 1855
-24 63 -65 174 -92 245 l-50 130 -148 3 -149 2 -22 -52 c-12 -29 -72 -174
-134 -323 -340 -827 -616 -1496 -764 -1855 -92 -223 -198 -479 -235 -570 -146
-355 -241 -586 -254 -615 -8 -16 -38 -90 -67 -162 -29 -73 -57 -133 -61 -133
-4 0 -8 833 -8 1850 l0 1850 -277 -2 -278 -3 -5 -1455 -5 -1455 -32 40 c-18
22 -124 155 -235 295 -111 140 -252 318 -313 395 -61 77 -178 225 -260 329
-298 376 -529 668 -588 740 -18 22 -50 63 -72 92 -81 105 -144 184 -335 424
-107 135 -256 322 -329 415 -74 94 -139 173 -145 177 -6 5 -119 7 -251 5
l-240 -2 -5 -1840 -5 -1840 -32 85 c-17 47 -55 146 -83 220 -29 74 -62 164
-75 200 -13 36 -46 124 -73 195 -183 486 -687 1826 -698 1855 -7 19 -49 132
-94 250 -44 118 -138 367 -207 553 l-127 337 -147 0 c-81 0 -150 -3 -152 -7z
m117 -1210 c16 -43 43 -116 61 -163 19 -47 84 -220 145 -385 143 -383 217
-578 241 -637 10 -26 19 -49 19 -52 0 -3 -234 -6 -519 -6 l-519 0 30 73 c34
81 475 1177 492 1220 6 15 13 27 16 27 3 0 18 -35 34 -77z m6640 -88 c109
-294 216 -581 235 -630 51 -127 191 -507 191 -515 0 -6 -191 -10 -516 -10
-409 0 -515 3 -511 13 9 22 272 674 392 972 64 160 121 301 126 314 6 14 13
20 18 15 5 -5 34 -76 65 -159z"
        />
        <path
          d="M5905 7628 c-3 -7 -4 -897 -3 -1978 l3 -1965 300 0 300 0 3 877 2
876 338 5 c293 4 350 7 437 26 220 46 398 121 549 229 156 113 306 296 382
468 94 212 113 491 48 702 -29 97 -91 227 -137 287 -211 278 -535 437 -967
475 -177 15 -1249 13 -1255 -2z m1215 -453 c167 -37 307 -110 401 -207 100
-104 156 -275 144 -435 -24 -316 -210 -529 -540 -618 -93 -26 -118 -28 -357
-32 l-258 -5 0 662 0 662 268 -5 c197 -4 287 -10 342 -22z"
        />
      </g>
    </SVGWrapper>
  );
};

export default Spana_Logo;
